<script setup>
import dateVisualForClient from '@/helpers/date/dateVisualForClient.js'
import FormFieldSelect from '@elements/FormFieldSelect.vue'
import SystemLanguageCollection from '@/modules/admin/collections/SystemLanguageCollection.js'
import useAbortController from '@/helpers/useAbortController.js'
import { computed, onMounted, ref } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { useI18n } from 'vue-i18n'
import { useNewsStore } from '@/stores/useNewsStore.js'

const APP_NAME = import.meta.env.VITE_APP_NAME

const i18n = useI18n()
const news = useNewsStore()
const signal = useAbortController()

const systemLanguageCollection = ref(new SystemLanguageCollection())
const newsList = computed(() => news?.list)

function fetchData() {
	systemLanguageCollection.value.fetchDropdown({
		signal,
		subData: false
	})
}

function saveLanguage() {
	localStorage.language = i18n.locale
}

onMounted(() => fetchData())
</script>

<template>
	<div class="auth-layout">
		<div class="auth-head text-center">
			<img
				:alt="`${APP_NAME} logo`"
				height="67"
				src="../../assets/nfo-logo.svg"
				width="298"
			>
		</div>

		<div class="auth-main">
			<router-view />
		</div>

		<div class="auth-foot">
			<div class="d-flex flex-wrap align-items-center justify-content-center gap-3">
				<a
					class="text-decoration-underline"
					href="https://normecfoodcareonline.zendesk.com"
					style="color: canvastext;"
					target="_blank"
				>
					{{ i18n.t('common.help') }}
				</a>
				<label class="d-flex gap-2 align-items-center">
					<span>{{ i18n.t('common.languages', 1) }} :</span>
					<FormFieldSelect
						v-model="i18n.locale.value"
						:loading="systemLanguageCollection.loading"
						:options="systemLanguageCollection.items.map(language => ({
							id: language.label,
							label: i18n.t(`common.locale-${language.label}`)
						}))"
						class="mbe-0"
						no-margin
						@update:model-value="saveLanguage"
					/>
				</label>
			</div>
		</div>

		<aside class="auth-aside">
			<div class="news-grid position-relative">
				<template
					v-for="item in newsList"
					:key="item.url"
				>
					<article
						v-show="item"
						class="news-item"
					>
						<div class="news-item-img">
							<img
								:alt="item.title"
								:src="item.img"
								loading="lazy"
							>
						</div>
						<div class="news-item-body">
							<div class="news-item-date">
								{{ dateVisualForClient(item.date) }}
							</div>
							<h3 class="news-item-heading">
								<a
									:href="item.url"
									target="_blank"
								>
									{{ item.title }}
								</a>
							</h3>
							<a
								:href="item.url"
								class="news-item-readmore"
							>
								<font-awesome-icon icon="arrow-right" />
								{{ i18n.t('common.readmore') }}
							</a>
						</div>
					</article>
				</template>
			</div>
		</aside>
	</div>
</template>
